import { render } from "./radio.vue?vue&type=template&id=66e2b075&scoped=true&ts=true"
import script from "./radio.vue?vue&type=script&lang=ts"
export * from "./radio.vue?vue&type=script&lang=ts"

import "./radio.vue?vue&type=style&index=0&id=66e2b075&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e2b075"]])

export default __exports__